// extracted by mini-css-extract-plugin
export default {"container":"horizontal-banner-list_container__VGMeh","label":"horizontal-banner-list_label__DOkzp","wrapper":"horizontal-banner-list_wrapper__TSjHm"};